import styled from 'styled-components';

export const Page = styled.div`
  position: relative;

  .main {
    background: none;
    padding-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/styles/index.style.js